import { RenderPlaceholderProps } from 'slate-react';
import React from 'react';

export const RenderSlatePlaceholderView = (props: RenderPlaceholderProps): JSX.Element => {
  const { children, attributes } = props;
  const { style, ...rest } = attributes;
  const newStyle: React.CSSProperties = {
    ...style,
    top: 0
  };
  return (
    <span {...rest} style={newStyle}>
      {children}
    </span>
  );
};
